import { useState } from 'react';
import { Pressable, View } from 'react-native';

import { IconInfoFill, Text, createMqStyles, tokens } from '@fhs/ui';

import { FoundationInformationModal } from './foundation-information-modal';

export default function DonationHeading({
  headerText,
  modalText,
}: {
  headerText: string;
  modalText: string | undefined;
}) {
  const mqStyles = useMqStyles();

  const [showDonationsInfoModal, setShowDonationsInfoModal] = useState(false);

  return (
    <>
      <View style={mqStyles.headingContainer}>
        <Text.Heading type="two" style={mqStyles.heading}>
          {headerText ?? ''}
        </Text.Heading>
        <Pressable
          onPress={() => setShowDonationsInfoModal(true)}
          accessibilityRole="button"
          accessibilityLabel="Show donations information modal"
        >
          <IconInfoFill size={30} color={tokens.colors.$black} />
        </Pressable>
      </View>

      {showDonationsInfoModal && (
        <FoundationInformationModal
          modalText={modalText}
          onClose={() => setShowDonationsInfoModal(false)}
        />
      )}
    </>
  );
}

const useMqStyles = createMqStyles({
  headingContainer: {
    $base: {
      height: 40,
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  heading: {
    $base: {
      color: tokens.colors.$black,
      fontSize: 14,
      flex: 1,
    },
    $gteDesktop: {
      fontSize: 16,
    },
    $ltDesktopLg: {
      fontSize: 14,
    },
  },
});
